import * as Sentry from "@sentry/nextjs";
import type { BasicUser } from "@common/types";

const setSentryUser = (user: BasicUser) => {
  Sentry.setUser(
    user
      ? {
          id: user.sub,
          email: user.email,
          username: user.name,
        }
      : null
  );
};

export { setSentryUser };
